import { DismissablePromptKey } from '@ms/yammer-data/dist/state/types';
import { useLoadDismissablePrompts } from '@ms/yammer-hooks/dist/dismissablePrompts';
import React, { ReactNode, Suspense } from 'react';

import LoadableAdminRebrandingBanner from '../LoadableAdminRebrandingBanner';
import LoadableNonAdminRebrandingBanner from '../LoadableNonAdminRebrandingBanner';

import { useShouldDisplayVivaEngageAdminRebrandingBanner } from './useShouldDisplayVivaEngageAdminRebrandingBanner';
import { useShouldDisplayVivaEngageNonAdminRebrandingBanner } from './useShouldDisplayVivaEngageNonAdminRebrandingBanner';

const promptKeys = [
  DismissablePromptKey.VivaEngageRebrandingNonAdminBanner,
  DismissablePromptKey.VivaEngageRebrandingAdminBanner,
];

type UseRebrandingBanner = () => ReactNode | null;
export const useRebrandingBanner: UseRebrandingBanner = () => {
  useLoadDismissablePrompts({ promptKeys });

  const shouldDisplayRegularBanner = useShouldDisplayVivaEngageNonAdminRebrandingBanner();
  const shouldDisplayAdminBanner = useShouldDisplayVivaEngageAdminRebrandingBanner();

  if (shouldDisplayRegularBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableNonAdminRebrandingBanner />
      </Suspense>
    );
  }

  if (shouldDisplayAdminBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableAdminRebrandingBanner />
      </Suspense>
    );
  }

  return null;
};
